<template>
  <div class="hello app-header-nav">
    <div style="height: 80px"></div>
    <div class="head">
      <div>
        <router-link :to="indivLinkEvalJees">
          <img class="logo" src="../../assets/newLogo-white.png" alt=""
        /></router-link>
        <ul class="nav_left">
          <li
            class="hdr-nav-pill"
            :class="{ 'hdr-nav-pill--active': isNavActive('eval') }"
            @click="push_eval_jees"
          >
            <img
              class="hdr-nav-pill__icon hdr-nav-pill__icon--zh"
              src="./img/zh.png"
              alt=""
              aria-hidden="true"
            />
            <span>账户列表</span>
          </li>
          <li
            class="hdr-nav-pill"
            :class="{ 'hdr-nav-pill--active': isNavActive('grouping') }"
            @click="push_grouping"
          >
            <img
              class="hdr-nav-pill__icon"
              src="./img/z.png"
              alt=""
              aria-hidden="true"
            />
            <span>账户组</span>
          </li>
          <li
            class="hdr-nav-pill"
            :class="{ 'hdr-nav-pill--active': isNavActive('help') }"
            @click="push_help"
          >
            <img
              class="hdr-nav-pill__icon hdr-nav-pill__icon--help"
              src="./img/bz.png"
              alt=""
              aria-hidden="true"
            />
            <span>帮助中心</span>
          </li>
          <li
            class="hdr-nav-pill"
            :class="{ 'hdr-nav-pill--active': isNavActive('download') }"
            @click="push_client_download"
          >
            <img
              class="hdr-nav-pill__icon"
              src="./img/zd.png"
              alt=""
              aria-hidden="true"
            />
            <span>终端下载</span>
          </li>
        </ul>
        <ul class="nav_right">
          <div class="login" v-if="userstate" @click="login">登录/注册</div>
          <li
            class="li_img liImg hdr-indiv-user"
            :class="{
              'hdr-indiv-user--verified': !showUnverifiedHint,
              'hdr-indiv-user--formal-active': showServiceSubline,
            }"
            v-if="!userstate"
            @mouseover="onUserHover"
            @mouseleave="user = false"
          >
            <div class="hdr-indiv-user__main">
              <div
                class="hdr-indiv-user__avatar-col"
                :class="{ 'hdr-indiv-user__avatar-col--vip': isVipUser }"
              >
                <img
                  v-if="showCrown"
                  class="hdr-indiv-user__crown"
                  :src="crownIconSrc"
                  alt=""
                  aria-hidden="true"
                />
                <div
                  class="hdr-indiv-user__avatar-media"
                  :class="{ 'hdr-indiv-user__avatar-media--uploaded': hasUserAvatar }"
                >
                  <img
                    class="hdr-indiv-user__avatar"
                    :class="{ 'hdr-indiv-user__avatar--uploaded': hasUserAvatar }"
                    :src="userAvatarUrl"
                    alt=""
                  />
                </div>
                <span
                  class="hdr-indiv-user__badge"
                  :class="showUnverifiedHint ? 'hdr-indiv-user__badge--warn' : 'hdr-indiv-user__badge--ok'"
                >{{ showUnverifiedHint ? '未实名' : '已实名' }}</span>
              </div>
              <div class="hdr-indiv-user__info">
                <div class="hdr-indiv-user__name-row">
                  <span
                    v-if="showUnverifiedHint"
                    class="hdr-indiv-user__name"
                    :title="indivAccountName"
                  >{{ indivAccountName }}</span>
                  <div v-else class="hdr-indiv-user__name-wrap">
                    <span
                      class="hdr-indiv-user__name"
                      :title="indivAccountName"
                    >{{ indivAccountName }}</span>
                    <img
                      v-if="showTrialBadge"
                      class="hdr-indiv-user__trial"
                      :src="trialTextIcon"
                      alt="试用中"
                    />
                    <img
                      v-else-if="showVipBadge"
                      class="hdr-indiv-user__vip"
                      :src="vipBadgeIcon"
                      alt="VIP"
                    />
                  </div>
                  <i
                    class="el-icon-arrow-down hdr-indiv-user__caret"
                    aria-hidden="true"
                  />
                </div>
                <a
                  v-if="showUnverifiedHint"
                  class="hdr-indiv-user__subline hdr-indiv-user__verify"
                  href="javascript:;"
                  @click.stop="openRealnameDialog"
                >去实名 &gt;</a>
                <span
                  v-else-if="showServiceSubline"
                  class="hdr-indiv-user__subline hdr-indiv-user__expire"
                  :class="{
                    'hdr-indiv-user__expire--date': !isServiceSublineExpired,
                    'hdr-indiv-user__expire--ended': isServiceSublineExpired,
                  }"
                >
                  <img
                    class="hdr-indiv-user__expire-bg"
                    :src="vipDateBg"
                    alt=""
                    aria-hidden="true"
                  />
                  <span class="hdr-indiv-user__expire-text">{{ serviceSublineText }}</span>
                </span>
              </div>
            </div>
            <transition name="el-fade-in-linear">
              <ul class="user" v-show="user">
                <a
                  style="border-bottom: 1px solid #edf0f6"
                  @click="push_account"
                  href="javascript:;"
                >
                  个人中心</a
                >
                <a @click="next">退出登录</a>
              </ul>
            </transition>
          </li>
        </ul>
      </div>
    </div>

    <RealnameDialog :visible.sync="showRealnameDialog" />
  </div>
</template>

<script>
import "./indiv-nav.css";
import {
  shouldShowRealnameHint,
} from "@/view/user/realname/realnameService";
import realnameDialogMixin from "@/view/user/realname/realnameDialogMixin";
import {
  subscriptionState,
  SERVICE_STATUS,
  VIEW_MODE,
  hadFormalSubscription,
  getSubscriptionExpireTime,
} from "@/view/user/subscriptionService/subscriptionService";
import {
  bootstrapIndivSession,
  resetIndivSession,
} from "@/view/user/indivSession/indivSessionService";
import { userAccountState } from "@/view/user/userAccount/userAccountService";
import vipIcon from "@/view/user/subscriptionService/img/vip.png";
import vipnoIcon from "@/view/user/subscriptionService/img/vipno.png";
import defaultAvatar from "@/view/client/personal-center/img/avatar.png";
import crownIcon from "@/view/client/personal-center/img/crown.png";
import crownIconExpired from "@/view/client/personal-center/img/crown-h.png";
import vipDateBg from "./img/vipDate.png";
import trialTextIcon from "@/view/client/personal-center/img/trialtext.png";

export default {
  name: "IndivNav",
  mixins: [realnameDialogMixin],
  data() {
    return {
      user: false,
      userstate: localStorage.getItem("token") ? false : true,
      vipDateBg,
      trialTextIcon,
    };
  },
  mounted() {
    this.bootstrapIndivSession();
  },
  computed: {
    indivLinkEvalJees() {
      return { path: "/user/eval_jees/list", query: { from: "indiv" } };
    },
    indivAccountName() {
      const u = this.$store.state.usermsg;
      if (u && typeof u === "object" && u.name) return String(u.name);
      return "";
    },
    userSelfImage() {
      return (
        (userAccountState.profile && userAccountState.profile.selfImage) ||
        (this.$store.state.usermsg && this.$store.state.usermsg.selfImage) ||
        ""
      );
    },
    hasUserAvatar() {
      return Boolean(this.userSelfImage);
    },
    userAvatarUrl() {
      return this.hasUserAvatar
        ? `${this.$store.state.api}${this.userSelfImage}`
        : defaultAvatar;
    },
    showUnverifiedHint() {
      return shouldShowRealnameHint();
    },
    /** 顶栏 VIP 角标：正式服务或试用期内已预购 */
    isVipUser() {
      return subscriptionState.view.vip;
    },
    /** 正式购买服务已过期（非试用到期） */
    isFormalServiceExpired() {
      const s = subscriptionState.status;
      if (!s || !s.hasService) {
        return false;
      }
      return (
        Number(s.serviceStatus) === SERVICE_STATUS.EXPIRED &&
        hadFormalSubscription(s)
      );
    },
    /** 展示 VIP 角标：有效 VIP 或正式服务已过期 */
    showVipBadge() {
      return this.isVipUser || this.isFormalServiceExpired;
    },
    /** 试用倒计时阶段：用户名后展示「试用中」 */
    isTrialActive() {
      return this.viewMode === VIEW_MODE.TRIAL;
    },
    showTrialBadge() {
      return this.isTrialActive;
    },
    showCrown() {
      return this.showVipBadge;
    },
    crownIconSrc() {
      return this.isFormalServiceExpired ? crownIconExpired : crownIcon;
    },
    vipBadgeIcon() {
      return this.isFormalServiceExpired ? vipnoIcon : vipIcon;
    },
    viewMode() {
      return subscriptionState.view.mode;
    },
    isTrialExpired() {
      return this.viewMode === VIEW_MODE.TRIAL_EXPIRED;
    },
    isFormalExpiredLayout() {
      return this.viewMode === VIEW_MODE.EXPIRED;
    },
    /**
     * 展示用到期时间（与侧栏 expireText 一致）
     * activeData.expireTime 优先，否则 getSubscriptionExpireTime
     */
    subscriptionExpireRaw() {
      const sub = subscriptionState.status;
      const active = subscriptionState.activeData;
      return (
        (active && active.expireTime) ||
        (sub && getSubscriptionExpireTime(sub)) ||
        ""
      );
    },
    subscriptionExpireDateText() {
      const expire = this.subscriptionExpireRaw;
      const dateOnly = expire ? String(expire).trim().split(/\s+/)[0] : "";
      return dateOnly ? `${dateOnly} 到期` : "";
    },
    /** 试用中 / 正式有效 / 试用预购：展示到期日；到期态展示红色提示 */
    showServiceSubline() {
      if (this.showUnverifiedHint) return false;
      if (this.isTrialExpired || this.isFormalExpiredLayout) return true;
      if (
        this.viewMode === VIEW_MODE.FORMAL ||
        this.viewMode === VIEW_MODE.TRIAL
      ) {
        return Boolean(this.subscriptionExpireDateText);
      }
      return false;
    },
    isServiceSublineExpired() {
      return this.isTrialExpired || this.isFormalExpiredLayout;
    },
    serviceSublineText() {
      if (this.isTrialExpired) return "您的试用已到期";
      if (this.isFormalExpiredLayout) return "您的服务已到期";
      return this.subscriptionExpireDateText;
    },
  },
  methods: {
    /** 悬停头像区展开下拉，点击「去实名」不展开 */
    onUserHover(e) {
      this.user = !e.target.closest(".hdr-indiv-user__verify");
    },
    /** 进入 indiv 时拉取订阅、实名、用户账户（各只请求一次） */
    bootstrapIndivSession() {
      if (this.userstate) {
        resetIndivSession();
        return;
      }
      bootstrapIndivSession({ store: this.$store });
    },
    /** 判断顶栏 pill 是否与当前路由匹配 */
    isNavActive(key) {
      const p = this.$route.path || "";
      if (key === "eval") return p.indexOf("/user/eval_jees/list") !== -1;
      if (key === "grouping") return p.indexOf("/client/grouping") !== -1;
      if (key === "help") return p.indexOf("/index/help/faq") !== -1;
      if (key === "download")
        return p.indexOf("/client/terminal-download") !== -1;
      return false;
    },
    /** 非帮助页不携带 help 的 type=9，避免从帮助页跳转时粘连到 URL */
    indivQueryWithoutHelpType() {
      const q = { ...(this.$route.query || {}) };
      if (String(q.type) === "9") delete q.type;
      return q;
    },
    push_eval_jees() {
      this.$router.push({
        path: "/user/eval_jees/list",
        query: { ...this.indivQueryWithoutHelpType(), from: "indiv" },
      });
    },
    push_grouping() {
      this.$router.push({
        path: "/client/grouping",
        query: { ...this.indivQueryWithoutHelpType(), from: "indiv" },
      });
    },
    push_help() {
      this.$router.push({
        path: "/index/help/faq",
        query: {
          ...this.indivQueryWithoutHelpType(),
          from: "indiv",
          type: "9",
        },
      });
    },
    push_client_download() {
      this.$router.push({
        path: "/client/terminal-download",
        query: { ...this.indivQueryWithoutHelpType(), from: "indiv" },
      });
    },
    /** 退出登录：清空 indiv 会话并刷新当前页 */
    next() {
      this.user = false;
      resetIndivSession();
      localStorage.removeItem("token");
      localStorage.removeItem("res");
      const query = this.isNavActive("help")
        ? { from: "indiv", type: "9" }
        : { ...this.indivQueryWithoutHelpType(), from: "indiv" };
      const search = new URLSearchParams(query).toString();
      window.location.href = `${this.$route.path}?${search || "from=indiv"}`;
    },
    /** 跳转个人中心（保留 indiv query，默认进入基本信息） */
    push_account() {
      this.user = false;
      this.$router.push({
        path: "/client/personal-center/basic",
        query: { ...this.indivQueryWithoutHelpType(), from: "indiv" },
      });
    },
    /** 未登录时跳转登录页，并记录返回地址 */
    login() {
      const q = { ...(this.$route.query || {}) };
      const path = this.$route.path;
      if (this.isNavActive("help")) {
        localStorage.setItem("path", `${path}?from=indiv&type=9`);
      } else {
        const returnQuery = { ...this.indivQueryWithoutHelpType(), from: "indiv" };
        const returnSearch = new URLSearchParams(returnQuery).toString();
        localStorage.setItem(
          "path",
          returnSearch ? `${path}?${returnSearch}` : path
        );
      }
      const loginQuery = { ...q, from: "indiv" };
      if (String(loginQuery.type) === "9") delete loginQuery.type;
      delete loginQuery.tab;
      if (loginQuery.type === "login" || loginQuery.type === "register") {
        delete loginQuery.type;
      }
      this.$router.push({ path: "/login", query: loginQuery });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/header/IndivNav.vue